export const eventBus = {
  on(event: any, callback: (e: CustomEvent) => void) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  dispatch(event: string, data: any) {
    document.dispatchEvent(new CustomEvent(event, {detail: data}));
  },
  remove(event: string, callback?: () => void) {
    if (callback) {
      document.removeEventListener(event, callback);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      document.removeEventListener(event, () => {});
    }
  },
};
